<template>
  <div>
    <MenuSuperior></MenuSuperior>
    <div class="container pb-5">
      <div class="row">
        <div class="col-3 d-none d-lg-block border-right pr-0 pt-3">
          <!-- Filtro lateral -->
          <Filtros
            :dados="dadosFiltro"
            :selecionados="filtroSelecionado"
            @limpar="onClickLimparFiltros"
          />
        </div>
        <div class="col-12 col-lg-9 pl-md-5 text-left">

          <div v-if="loadingAnunciosDestaques" class="p-5">Carregando...</div>
    <BlocosAnuncios
     v-else
     titulo="Anúncios destaques"
      imagem="/img/bike_trilha.jpg"
       :items="anunciosDestaques"
        :destaques="true"
     ></BlocosAnuncios>

          <h2 class="mt-3" ref="tituloResultadosPesquisa">Resultados da pesquisa</h2>
          <div class="row small-gutters mb-3">
            <div class="col-8 col-lg-4 mb-2">
              <!-- Campo ordenação -->
              <div class="input-group">
                <div class="input-group-prepend">
                  <label class="input-group-text" for="inputOrdenacaoResultadosPesquisa">
                    <b-icon icon="arrow-up-down"></b-icon>
                  </label>
                </div>
                <select
                  class="custom-select"
                  id="inputOrdenacaoResultadosPesquisa"
                  v-model="ordenarPor"
                  @change="pesquisar"
                >
                  <!-- <option value="relevantes" value="">Mais relevantes</option> -->
                  <option :value="config.ORDEM_ANUNCIOS_MAIS_RECENTES">Mais recentes</option>
                  <option :value="config.ORDEM_ANUNCIOS_MENOR_PRECO">Menor preço</option>
                  <option :value="config.ORDEM_ANUNCIOS_MAIOR_PRECO">Maior preço</option>
                </select>
              </div>
            </div>
            <div class="col-4 d-lg-none">
              <button class="btn btn-light-gray btn-block" v-b-modal.modal-filtros>
                <b-icon icon="list-ul"></b-icon>Filtros
              </button>
            </div>
            <div class="col-12 col-lg-8">
              <TagsFiltrosSelecionados
                :filtroSelecionado="filtroSelecionado"
                :dadosFiltro="dadosFiltro"
              />
            </div>
          </div>



          <div v-if="loadingPesquisa" class="p-5">Carregando...</div>
          <ResultadosPesquisa
            v-if="!loadingPesquisa"
            :dados="resultadoPesquisa"
            :paginaAtual="paginaAtual"
            :qtdPorPagina="qtdPorPagina"
            :qtdTotal="qtdTotal"
            @change-pagina="onChangePagina"
          ></ResultadosPesquisa>
        </div>
      </div>
    </div>

    <Rodape />

    <b-modal id="modal-filtros" title="Filtros" scrollable @show="onOpenModalFiltros">
      <Filtros
        :dados="dadosFiltro"
        :selecionados="filtroSelecionadoModal"
        @limpar="onClickLimparFiltrosModal"
      />

      <template v-slot:modal-footer="{ hide }">
        <button
          @click="onClickAplicarFiltrosModal(hide)"
          class="btn btn-primary btn-block"
        >Aplicar filtros</button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";

import config from "../config";
import smoothScroll from "../helpers/smoothScroll";
import captureError from "../helpers/captureError";

import MenuSuperior from "../components/MenuSuperior";
import TagsFiltrosSelecionados from "../components/TagsFiltrosSelecionados";
import Filtros from "../components/Filtros";
import ResultadosPesquisa from "../components/ResultadosPesquisa";
import BlocosAnuncios from "../components/BlocosAnuncios";
import Rodape from "../components/Rodape";

export default {
  components: {
    MenuSuperior,
    TagsFiltrosSelecionados,
    Filtros,
    ResultadosPesquisa,
    Rodape,
    BlocosAnuncios
  },
  data() {
    return {
      config,

      dadosFiltro: {},
      filtroSelecionado: {
        termoPesquisa: ''
      },
      filtroSelecionadoModal: {},
      loadingFiltro: true,
      loadingPesquisa: true,
      loadingAnunciosDestaques: true,
      anunciosDestaques: [],
      resultadoPesquisa: [],
      ordenarPor: 0,

      paginaAtual: 1,
      qtdPorPagina: 12,
      qtdTotal: 0
    };
  },
  created() {
    //console.log("created");
    this.montarFiltroInicialLocalStorageParametroUrl();

    this.popularFiltro();
    this.popularAnunciosDestaques(4);
    //this.pesquisar();
  },
  watch: {
    
    filtroSelecionado: {
      deep: true,
      handler: function() {
        //newValue, oldValue
        //console.log("filtro", value);
        //var jsonValue = JSON.stringify(value);
        // var jsonOldValue = JSON.stringify(oldValue);
        // if (jsonValue != jsonOldValue) {
        //if (value != oldValue) {
        // this.filtroSelecionadoModal = JSON.parse(jsonValue);

        this.pesquisar();
        //}
      }
    }
    // paginaAtual: function(value, oldValue) {
    //   if (value != oldValue) {
    //     this.pesquisar(true);
    //   }
    // }
  },
  methods: {
    async popularAnunciosDestaques(quantidade) {
      try {
        this.loadingAnunciosDestaques = true;

        var response = await axios.get(config.API_URL + "/anuncio/destaques?quantidade="+quantidade);

        this.anunciosDestaques = response.data;

        this.loadingAnunciosDestaques = false;
      } catch (e) {
        captureError(e);
        this.loadingAnunciosDestaques = false;

        Swal.fire({
          type: "error",
          title: "Oops...",
          text:
            "Não foi possível carregar os anúncios Destaques. Tente novamente mais tarde ou contate o suporte.",
        });
      }
    },
    verificaFiltroPreenchido(filtro) {
      var preenchido =
        filtro &&
        (filtro.estado ||
          filtro.termoPesquisa ||
          filtro.preco ||
          (filtro.modalidade && filtro.modalidade.length > 0) ||
          (filtro.quadro && filtro.quadro.length > 0) ||
          (filtro.aro && filtro.aro.length > 0));
      return preenchido;
    },
    montarFiltroInicialLocalStorageParametroUrl() {
      var filtro = { condicao: "", modalidade: [] };

      var filtroPesquisaSalvo = window.localStorage.getItem("filtroPesquisa");
      if (filtroPesquisaSalvo) {
        filtro = JSON.parse(filtroPesquisaSalvo);
      }

      if (!this.verificaFiltroPreenchido(filtro)) {
        var estado = this.$route.query.e;
        var modalidade = this.$route.query.m;
        var termoPesquisa = this.$route.query.p;
        var idVendedor = this.$route.query.v;

        if (estado) {
          filtro.estado = estado;
        }

        if (modalidade) {
          filtro.modalidade = [modalidade.toLowerCase()];
        }

        if (termoPesquisa) {
          filtro.termoPesquisa = termoPesquisa;
        }

        if (idVendedor) {
          filtro.idVendedor = idVendedor;
        }
      }

      var filtroCopia = JSON.parse(JSON.stringify(filtro));

      this.filtroSelecionado = filtro;
      this.filtroSelecionadoModal = filtroCopia;
    },
    async popularFiltro() {
      try {
        this.loadingFiltro = true;

        var response = await axios.get(config.API_URL + "/anuncio/dadosFiltro");

        this.dadosFiltro = response.data;

        this.loadingFiltro = false;
      } catch (e) {
        captureError(e);
        this.loadingFiltro = false;
        Swal.fire({
          type: "error",
          title: "Oops...",
          text:
            "Não foi possível carregar os dados do filtro. Tente novamente mais tarde ou contate o suporte."
        });
      }
    },
    async pesquisar(manterPagina) {
      try {
        this.loadingPesquisa = true;

        if (!manterPagina) {
          this.paginaAtual = 1;
        }

        var data = {
          condicao: this.filtroSelecionado.condicao,
          marcaModelo: this.filtroSelecionado.termoPesquisa,
          idUf: this.filtroSelecionado.estado,
          estrelas: [],
          quadros: this.filtroSelecionado?.quadro || [],
          aros: this.filtroSelecionado?.aro || [],
          tiposBike: this.filtroSelecionado.modalidade,
          ordenarPor: this.ordenarPor,
          pagina: this.paginaAtual - 1,
          quantidadePorPagina: this.qtdPorPagina,
          idVendedor: this.filtroSelecionado.idVendedor
        };

        //Convertendo estrutura do filtro de preço
        if (this.filtroSelecionado.preco) {
          var valores = this.filtroSelecionado.preco.split("-");
          data.precoMin = parseInt(valores[0]) || undefined;
          data.precoMax = parseInt(valores[1]) || undefined;
        }

        var response = await axios.post(
          config.API_URL + "/anuncio/pesquisar",
          data
        );

        this.resultadoPesquisa = response?.data;
        this.qtdTotal = response?.data?.total;

        this.salvarFiltroPesquisa();

        this.loadingPesquisa = false;
      } catch (e) {
        captureError(e);
        this.loadingPesquisa = false;
        Swal.fire({
          type: "error",
          title: "Oops...",
          text:
            "Não foi possível realizar a pesquisa. Tente novamente mais tarde ou contate o suporte."
        });
      }
    },
    onClickAplicarFiltrosModal(hide) {
      //Aplica o filtro da modal no filtro principal
      var copy = JSON.parse(JSON.stringify(this.filtroSelecionadoModal));
      this.filtroSelecionado = copy;

      hide(true);
    },
    onOpenModalFiltros() {
      //Copia o fitro principal para o filtro da modal
      var copy = JSON.parse(JSON.stringify(this.filtroSelecionado));
      this.filtroSelecionadoModal = copy;
    },
    onClickLimparFiltros() {
      this.filtroSelecionado = this.getFiltroVazio();
    },
    onClickLimparFiltrosModal() {

      this.filtroSelecionadoModal = this.getFiltroVazio();
      this.filtroSelecionado = this.getFiltroVazio();

      this.$bvModal.hide('modal-filtros');
    },
    getFiltroVazio() {
      return {
        termoPesquisa: undefined,
        estado: undefined,
        estrelas: [],
        quadro: [],
        aro: [],
        modalidade: []
      };
    },
    onChangePagina(pagina) {
      this.paginaAtual = pagina;

      var elm = this.$refs.tituloResultadosPesquisa;
      smoothScroll.smoothScrollYToElement(elm, 400);

      this.pesquisar(true);
    },
    salvarFiltroPesquisa() {
      if (this.filtroSelecionado) {
        var filtro = JSON.stringify(this.filtroSelecionado);
        window.localStorage.setItem("filtroPesquisa", filtro);
      }
    }
  }
};
</script>
